var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4931 55.099C11.0708 56.4765 12.5738 57.2192 14.0188 56.8412L44 49L37.8884 36.2139C37.2728 34.9259 35.8349 34.2502 34.4504 34.5981L8.38518 41.1492C6.6041 41.5968 5.63964 43.5253 6.34985 45.2189L10.4931 55.099Z",
    fill: "#DFE2E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3752 71.2268C66.8587 72.3057 67.9307 73 69.1129 73H93.3682C95.5432 73 96.9953 70.758 96.1059 68.7732L90.8302 57H60L66.3752 71.2268Z",
    fill: "#C4C2F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49L91 57V92L44 84V49Z",
    fill: "#DFE2E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57L44 49V84L13 92V57Z",
    fill: "#A6ABB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57L60 65V100L13 92V57Z",
    fill: "#C4C2F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65L91 57V92L60 100V65Z",
    fill: "#5E62CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5938 49.3657C66.9569 48.5049 67.7002 47.8624 68.6045 47.6277L92.1227 41.5251C94.5283 40.9009 96.6062 43.3048 95.6404 45.5947L90.8302 57L60 65L66.5938 49.3657Z",
    fill: "#C4C2F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60 66V99.0734C60 99.5428 59.5572 99.886 59.1026 99.7691L52.4288 98.0515C36.2322 93.8833 23.3167 81.6799 18.2376 65.7454C18.12 65.3766 18.3953 65 18.7823 65H59C59.5523 65 60 65.4477 60 66Z",
    fill: "#5E62CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0401 58.5938C10.6951 57.6224 11.8557 57.1212 13.0119 57.3105L60 65L49.9768 79.4063C49.302 80.3761 48.1209 80.8596 46.9598 80.6412L3.98912 72.562C2.57586 72.2963 1.89648 70.6705 2.70046 69.4783L10.0401 58.5938Z",
    fill: "#DFE2E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1842 36.6416C58.3917 35.7861 59.6083 35.7861 59.8158 36.6416L60.3866 38.9955C60.4606 39.3009 60.6991 39.5394 61.0045 39.6134L63.3584 40.1842C64.2139 40.3917 64.2139 41.6083 63.3584 41.8158L61.0045 42.3866C60.6991 42.4606 60.4606 42.6991 60.3866 43.0045L59.8158 45.3584C59.6083 46.2139 58.3917 46.2139 58.1842 45.3584L57.6134 43.0045C57.5394 42.6991 57.3009 42.4606 56.9955 42.3866L54.6416 41.8158C53.7861 41.6083 53.7861 40.3917 54.6416 40.1842L56.9955 39.6134C57.3009 39.5394 57.5394 39.3009 57.6134 38.9955L58.1842 36.6416Z",
    fill: "#C4C2F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3148 12.7031C80.8283 11.9695 81.6553 11.0771 82.4238 11.5064L84.5382 12.6878C84.8126 12.8411 85.1496 12.8283 85.4115 12.6546L87.4302 11.3161C88.1638 10.8297 89.0562 11.6567 88.6269 12.4251L87.4455 14.5396C87.2922 14.814 87.305 15.151 87.4787 15.4129L88.8172 17.4315C89.3036 18.1652 88.4766 19.0576 87.7082 18.6282L85.5937 17.4468C85.3193 17.2936 84.9823 17.3064 84.7204 17.48L82.7017 18.8185C81.9681 19.305 81.0757 18.478 81.5051 17.7095L82.6864 15.5951C82.8397 15.3207 82.8269 14.9837 82.6532 14.7218L81.3148 12.7031Z",
    fill: "#C4C2F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1842 1.6416C39.3917 0.786133 40.6083 0.786132 40.8158 1.6416L41.3866 3.99548C41.4606 4.30091 41.6991 4.53938 42.0045 4.61344L44.3584 5.18423C45.2139 5.39166 45.2139 6.60834 44.3584 6.81578L42.0045 7.38656C41.6991 7.46062 41.4606 7.69909 41.3866 8.00452L40.8158 10.3584C40.6083 11.2139 39.3917 11.2139 39.1842 10.3584L38.6134 8.00452C38.5394 7.69909 38.3009 7.46062 37.9955 7.38656L35.6416 6.81578C34.7861 6.60834 34.7861 5.39166 35.6416 5.18423L37.9955 4.61344C38.3009 4.53938 38.5394 4.30091 38.6134 3.99548L39.1842 1.6416Z",
    fill: "#C4C2F4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 26.5,
    r: 1.5,
    fill: "#5E62CC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 17.5,
    r: 1.5,
    fill: "#5E62CC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 16.5,
    r: 1.5,
    fill: "#5E62CC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 35.5,
    r: 1.5,
    fill: "#5E62CC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 55.5,
    r: 1.5,
    fill: "#5E62CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.52d15db174bd6ea9558c186f81c87649.svg";
export { ForwardRef as ReactComponent };